module.exports = __webpack_public_path__ + "img/password.3108d3e6.svg";